module.exports = __webpack_public_path__ + "img/img_04.91bc9c5c.jpg";